import { objType } from "types";

const words: objType = {
    dragHere:   'גררו תבניות לכאן',
    submit:     'אישור',
    success:    'כל הכבוד!',
    goHome:     'לדף הבית',
    next:       'לתרגיל הבא',
    nextLevel:  'לשלב הבא',
    level:      'שלב',
    goToTirgul: 'התחילו תרגול',
    continue:   'המשך',
    mazeget:    'התחילו מצגת הדגמה',
    tirgul:     'התחילו תרגול',
    answer:     'תשובה',
    zeroInput:  'איפוס'
}

export default words